export default __webpack_public_path__ + "static/media/TransparentCoin.666ce204.png";